var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "vx-row mb-2" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full" },
          [
            _c(
              "b-button",
              {
                class: ["float-right"],
                attrs: { variant: "outline-primary", type: "submit" },
                on: { click: _vm.addNewOrganizationUnit }
              },
              [
                _c("feather-icon", {
                  staticClass: "mr-50",
                  attrs: { icon: "PlusIcon" }
                }),
                _c("span", { staticClass: "align-middle" }, [
                  _vm._v("Adicionar Nova Unidade")
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._l(_vm.organizationalUnitList, function(organizationalUnit) {
        return _c("div", { key: organizationalUnit, staticClass: "vx-row" }, [
          _c(
            "div",
            { staticClass: "vx-col w-full" },
            [
              _c("OrganizationalUnit", {
                attrs: {
                  organizationalUnit: organizationalUnit,
                  services: _vm.services
                },
                on: { destroy: _vm.destroyOrganizationalUnit }
              })
            ],
            1
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }